// Client wrappers for /api/field-assistant. The chatting player_id is
// always derived server-side from the session cookie.

const TRIP_DEFAULT = 'juneau-2026';

async function jsonOrThrow(res) {
  let data;
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  if (!res.ok) {
    const err = new Error(data.message || data.error || `assistant → ${res.status}`);
    err.status = res.status;
    err.detail = data;
    throw err;
  }
  return data;
}

export async function fetchChatHistory({ tripId = TRIP_DEFAULT } = {}) {
  const res = await fetch(`/api/field-assistant?trip_id=${tripId}`, { credentials: 'include' });
  const ct = res.headers.get('content-type') || '';
  if (!res.ok || !ct.includes('json')) {
    const err = new Error('history_unavailable');
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function sendChatMessage({ tripId = TRIP_DEFAULT, message }) {
  const res = await fetch('/api/field-assistant', {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ trip_id: tripId, message }),
  });
  return jsonOrThrow(res);
}

export async function clearChatHistory({ tripId = TRIP_DEFAULT } = {}) {
  const res = await fetch(`/api/field-assistant?trip_id=${tripId}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  return jsonOrThrow(res);
}
